export function getIsConfigLoaded(state, key) {
	return state.configOriginal.byKey[key] && state.configDraft.byKey[key];
}
